var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-subheader',[_vm._v("Admin")]),_c('v-list-item',{attrs:{"link":"","to":"/admin/api"}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-api")])],1),_c('v-list-item-title',[_vm._v("Manage API")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }